// REDESIGN 2024

// import * as Sentry from '@sentry/browser';
import { configureMegaMenu } from './configureMegaMenu.ts';
import { breakingNewsElement } from './navigationElements.ts';

export const navigation = (navigation: HTMLElement) => {
    const navigationToggle = navigation.querySelector('[data-navigation-open]');
    const fullNav: HTMLElement | null = document.querySelector('.blesk-full-nav');
    const html: HTMLElement | null = document.documentElement;

    if (!navigationToggle || !fullNav) {
        // Sentry.captureException('navigation: Chybí některý z elementů navigace');
        return;
    }

    // Přidat na body třídu 'body--navigation'
    document.body.classList.add('body--navigation');

    // Otevřít 'megamenu' (černá plachta přes celou obrazovku)
    navigationToggle.addEventListener('click', () => {
        fullNav.classList.add('blesk-full-nav--show');
        html.style.overflow = 'hidden';
    });

    // Kvůli nejednotnému starému designu...
    handleWrapperSpacings(navigation);

    // Nakonfigurovat megamenu - černá plachta přes celou obrazovku
    configureMegaMenu();
};

// Vizuálně ošetřit nesourodost obalových elementů na úrovni design-base (pro desktop)
// TODO: do budoucna po redesign design-base šablon by mělo jít smazat
export const handleWrapperSpacings = (navigation: HTMLElement | null) => {
    const wrapper = navigation?.parentElement;
    const navigationHeight = navigation?.clientHeight;

    // zastavit, pokud je v těle element s id 'article-top-img' (použit pouze v mobilni verzi) nebo class 'grid-container' (nový responzivní design)
    const articleTopImgElement = document.querySelector('#article-top-img');
    if (articleTopImgElement)
        return;
    const gridContainer: HTMLElement | null = document.querySelector('.grid-container');
    if (gridContainer)
        return;

    const dynamicNavigation: HTMLElement | null = document.querySelector(
        '[data-dynamic-navigation]',
    );
    const dynamicNavigationHeight = dynamicNavigation?.clientHeight || 0;

    // Přidat padding-top na wrapper, aby se obsah nepřekrýval s navigací
    if (wrapper && navigationHeight && !breakingNewsElement) {
        wrapper.style.paddingTop = `${navigationHeight + dynamicNavigationHeight - 2}px !important`;
    }
};
